export default __webpack_public_path__ + "static/ak-cached/24h/media/mob-ordering-page-hero-netflix.ad82080a.jpg";